import rest from "@/rest-client";
import vuexStore from "@/store/customSaveStore";

import { storageRecommendation } from "../../recommendation/storage/store";

export const datasourcePhysicalStorage = vuexStore({
  namespaced: true,
  path: "/datasource-physical-storage",
  state: {
    editedDatasource: null,
    // TKP-74: veri kartından girilen kayıt düğüme bağlanır (kaynak yok)
    editedProcessData: null,
    editedPhysicalStorage: null,
    ...storageRecommendation.state,
  },
  getters: {
    editedDatasource: (state) => state.editedDatasource,
    editedProcessData: (state) => state.editedProcessData,
    editedPhysicalStorage: (state) => state.editedPhysicalStorage,
    ...storageRecommendation.getters,
  },
  mutations: {
    editedDatasource: (state, value) => (state.editedDatasource = value),
    editedProcessData: (state, value) => (state.editedProcessData = value),
    editedPhysicalStorage: (state, value) => (state.editedPhysicalStorage = value),
    ...storageRecommendation.mutations,
  },
  actions: {
    ...storageRecommendation.actions,
    /** TKP-64: fiziksel VE elektronik saklama kaydı (`kind`) — yalnız verilen alanlar (başlangıç, süre/ay, yasal dayanak). */
    async updateRetention(_, { _id, kind, since, period, legalBasis, libraryItem }) {
      // TKP-204: ortam (kütüphane kalemi) da aynı uçtan — verilmezse dokunulmaz
      return rest.put("/datasource-storage/retention", { _id, kind, since, period, legalBasis, ...(libraryItem && libraryItem._id ? { libraryItem } : {}) });
    },
  },
});

export const organizationPhysicalStorage = vuexStore({
  namespaced: true,
  path: "/physical-storage",
});
